import React from 'react'
import Header2 from '../Layout/Header2'
import Footer from '../Layout/Footer'
import Review from '../components/review/Review'
export default function ImageRev() {
  return (
    <div>
              <Header2/>
      <Review/>
      <Footer/> 
    </div>
  )
}
